module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "Chapter_3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "chtitle"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062192523_Contents#Chapter_3"
    }
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "images/ch03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noIndent"
  }, [_vm._v("“"), _c('span', {
    staticClass: "dp"
  }, [_vm._v("M")]), _vm._v("r. Walker?” Angel asked, suddenly worried about his job. “I’m sorry. I didn’t recognize you!”")]), _vm._v(" "), _c('p', [_vm._v("Their father would have been hard for anyone to recognize. He was wearing a ski jacket, torn jeans, loafers without socks, a tattered San Francisco Giants cap, and aviator sunglasses, with a plaid scarf wrapped around his neck. He was crossing the street in a hurry, headed for a deli, while a double-parked cab waited across the way. Mr. Walker saw Angel and put on a smile.")]), _vm._v(" "), _c('p', [_vm._v("“Kids! Hey! Angel, don’t worry about it.” He walked to the rear passenger window. Cars honked at him. He looked like he’d been up all night.")]), _vm._v(" "), _c('p', [_vm._v("“Mom said you were out for a run,” Brendan said.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v(" "), _c('p', [_vm._v("“I was working. Your mother tries to shield you from the amount of work I do. But I’m really trying to get my old position back, and that means doing time-consuming research.”")]), _vm._v(" "), _c('p', [_vm._v("“We understand,” Eleanor said. “We love you, Dad.”")]), _vm._v(" "), _c('p', [_vm._v("“What kind of research?” Brendan asked, concerned about his dad—and wanting to believe him.")]), _vm._v(" "), _c('p', [_vm._v("“Medical research. Blood flow and reward centers in the brain. Look, I’m grabbing a sandwich and going home. You kids have a great day at school. I love you.” He kissed his hand, reached through the window, and patted each of their heads.")]), _vm._v(" "), _c('p', [_vm._v("Then he was off, into the deli. The Walkers looked at one another.")]), _vm._v(" "), _c('p', [_vm._v("“Maybe he’s going insane. Maybe the book cursed him,” Cordelia said.")]), _vm._v(" "), _c('p', [_vm._v("“Or maybe he’s just got too much money,” said Brendan.")]), _vm._v(" "), _c('p', [_vm._v("“Maybe I should have wished for like half as much,” Eleanor said guiltily.")]), _vm._v(" "), _c('p', [_vm._v("They rode in silence the rest of the way to school.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77a97198","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062192523_Chapter_3.vue
// module id = 72
// module chunks = 0